<template>
  <div class="channel_detail" >
      <div @click="closeDetail" class="close"/>
      <div class="table">
      <el-table  :data="detail_list" border :row-class-name="channelDetailRowInfo" :cell-class-name="channelDetailCellInfo">
        <el-table-column fixed prop="name" label="Details">
        </el-table-column>
        <el-table-column prop="value" label="">
        </el-table-column>
      </el-table>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detail_list:[],
      }
    },
    props:{
        channel_id:{
            type:Number,
            default(){return 0},
        }
    },
    watch:{
        channel_id: async function(channel_id) {
            // console.log(channel_id);
            if(channel_id == 0){
                return;
            }
            const detail_data = await this.$post('/channel/detail',{channel_id:channel_id});
            // let api_url = '';
            // const api_url_obj = JSON.parse(detail_data.api_url);
            // for(const flag in api_url_obj){
            //     api_url += flag+" : "+api_url_obj[flag];
            // }
            const result = [
                {
                    "name":"Basic Details",
                    "value":""
                },
                {
                    "name":"Channel Name",
                    "value":detail_data.channel_name,
                },
                {
                    "name":"Channel Type",
                    "value":detail_data.channel_type,
                },
                {
                    "name":"Account Level",
                    "value":"Level "+detail_data.account_level.toUpperCase(),
                },
                {
                    "name":"Status",
                    "value":detail_data.status.toUpperCase(),
                },
                {
                    "name":"Login Email",
                    "value":detail_data.email,
                },
                {
                    "name":"Deduction Rate(%)",
                    "value":detail_data.defraud*100+"%",
                },
                {
                    "name":"Payout Rate(%)",
                    "value":detail_data.price_percent*100+"%",
                },
                {
                    "name":"API Token",
                    "value":detail_data.api_token,
                },
                {
                    "name":"API Url",
                    "value":detail_data.api_url,
                },
                {
                    "name":"Insertion Order(IO)",
                    "value":detail_data.io_file==null?"Unsigned":"Signed",
                },
                {
                    "name":"Remark",
                    "value":detail_data.remark,
                },
                {
                    "name":"Creator",
                    "value":detail_data.creator,
                },
                {
                    "name":"Create Time",
                    "value":detail_data.createdAt,
                },
                {
                    "name":"Modify Time",
                    "value":detail_data.updatedAt,
                }
            ];
            this.detail_list = result;
        }
    },
    methods: {
        channelDetailRowInfo({row, rowIndex}) {
            if (rowIndex === 0) {
                return 'adv-detail-title-info';
            }
                return '';
        },
        channelDetailCellInfo({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 1) {
                if(row.value == 'PAUSED') {
                    return "status-paused";
                }
                else if(row.value == 'ACTIVE') {
                    return "status-active";
                }
                if(row.value == 'Unsigned') {
                    return "status-paused";
                }
                else if(row.value == 'Signed') {
                    return "status-active";
                }
            }
        },
        closeDetail() {
            this.rootGetAdvDetail(0,'channel');
        }
    },
	inject: ['rootGetAdvDetail'],
  }
</script>

<style scoped>

.channel_detail{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
}
.close{
    flex-grow:100;
    height: 100%;

}
.table{
    width:40%;
    height: 100%;
    overflow: scroll;
}

</style>